import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HxCallcenterService } from 'hx-services';
import { NgClass, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hx-add-call-modal',
    templateUrl: './add-call.component.html',
    styleUrls: ['./add-call.component.css'],
    imports: [NgIf, NgClass, TranslocoPipe]
})
export class HxAddCallModalComponent {

  @Input() orderNumber?: string;
  @Input() orderId!: number;
  @Input() callId!: string;
  @Input() clientPhone!: string;
  isLoading = false;

  constructor(private modalRef: NgbActiveModal,
              private callcenterService: HxCallcenterService) {
  }

  async add() {
    this.isLoading = true;
    try {
      await this.callcenterService.addOrderToCall({orderId: this.orderId, callId: this.callId});
      this.modalRef.close();
    } finally {
      this.isLoading = false;
    }
  }

  close() {
    this.modalRef.dismiss();
  }
}
